"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = exports.env = exports.defaultPlayerScript = exports.token = exports.KIJK_API_URL = exports.PLAYER_CONFIG_URL = void 0;
exports.PLAYER_CONFIG_URL = 'https://embed.test.kijk.nl/api/playerconfig';
exports.KIJK_API_URL = 'https://graph.kijk.nl/graphql';
exports.token = '89bab3c0-36bb-11ea-bfaf-c9aea08d9fb6';
exports.defaultPlayerScript = 'https://ssl.p.jwpcdn.com/player/v/8.18.0/jwplayer.js';
exports.env = 'development';
exports.version = '0.1.94';
